import { useFormatPrice } from '@packages/shared';

export type UsePriceFormaterTargetTypes = 'PRODUCT' | 'APLUS' | 'ATB' | 'INSTALLMENTCALCULATOR';
export type FormatPricePrice = Parameters<ReturnType<typeof useFormatPrice>['formatPrice']>[0];
export type FormatPriceCurrency = Parameters<ReturnType<typeof useFormatPrice>['formatPrice']>[1];

function getPrice(price: FormatPricePrice, targetType: UsePriceFormaterTargetTypes) {
  switch (targetType) {
    case 'APLUS':
    case 'INSTALLMENTCALCULATOR': {
      return Math.round(price * 100);
    }
    case 'PRODUCT':
    case 'ATB':
    default: {
      return price;
    }
  }
}

export const usePriceFormater = (targetType: UsePriceFormaterTargetTypes) => {
  const { formatPrice } = useFormatPrice();

  return (price: FormatPricePrice, currency: FormatPriceCurrency) =>
    formatPrice(getPrice(price, targetType), currency);
};
